import React from "react";
import {BackButton} from "@/components";
import {StickyHeader, YStack, Separator, XStack, Button} from "@chayka/ui";
import {MailOutline, CallOutline, LogoVk, LogoYoutube, PaperPlaneOutline} from "@chayka/icons";

const ContactItem: React.FC<{
  title: string;
  value: string;
  href: string;
  icon?: React.ReactNode;
}> = ({title, value, href, icon}) => {
  return (
    <a
      className="flex flex-row gap-4 justify-between items-center"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <YStack className="gap-1">
        <div className="text-l font-semibold">{title}</div>
        <div className="text-sm text-secondary-text flex items-center gap-2">{value}</div>
      </YStack>
      {icon}
    </a>
  );
};

const CONTACT_ITEMS = [
  {
    title: "Почта",
    value: "chaykastudia@gmail.com",
    href: "mailto:chaykastudia@gmail.com",
    icon: <MailOutline size={30} />,
  },
  {
    title: "Телефон",
    value: "+7 (991) 945-75-75",
    href: "tel:+79919457575",
    icon: <CallOutline size={30} />,
  },
  {
    title: "Сайт",
    value: "https://chaykastudia.ru",
    href: "https://chaykastudia.ru",
  },
];

export const ContactsPage = () => {
  return (
    <YStack className="gap-4">
      <StickyHeader title="Наши контакты" leftPart={<BackButton />} />
      <h1 className="text-xl font-light">Способы связи</h1>
      {CONTACT_ITEMS.map((item) => (
        <React.Fragment key={item.title}>
          <ContactItem {...item} />
          <Separator />
        </React.Fragment>
      ))}
      <XStack className="gap-4">
        <a href="https://vk.com/chayka_studia" target="_blank" rel="noopener noreferrer">
          <LogoVk size={30} />
        </a>
        <a
          href="https://www.youtube.com/channel/UCJTdTkr2ctU4q_uuIvXO3uQ"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LogoYoutube size={30} />
        </a>
        <a href="https://t.me/chaykastudia" target="_blank" rel="noopener noreferrer">
          <PaperPlaneOutline size={30} />
        </a>
      </XStack>
      <YStack className="gap-1 text-sm">
        <div>Москва, Ленинградский проспект 47, стр. 1</div>
        <div>Метро «Аэропорт»</div>
      </YStack>
      <Button
        onClick={() =>
          window.open("https://maps.app.goo.gl/jYNVJJLJTHT9qohd9", "_blank", "noopener noreferrer")
        }
        size="medium"
        variant="secondary"
      >
        Поделиться геопозицией
      </Button>
    </YStack>
  );
};
